import React from 'react'
import cn from 'classnames'
import { renderRichTextMultiLineContent } from '@components/renderer/rich-text'
import { Document, Table } from '@contentful/rich-text-types'
import { TableCell, TableCellConfig } from './table-cells/table-cell'
import { TableHeaderCell, TableHeaderCellConfig } from './table-cells/table-header-cell'
import styles from './table-view.module.scss'

export interface TableViewProps {
  table: Table
  primaryHeader?: boolean
  firstRowAsHeader?: boolean
  firstColumnAsHeader?: boolean
  zebraStriping?: boolean
  headerCellConfig?: TableHeaderCellConfig
  cellConfig?: TableCellConfig
}

export const TableView: React.FC<TableViewProps> = ({
  table,
  headerCellConfig,
  cellConfig,
  primaryHeader = false,
  firstRowAsHeader = false,
  firstColumnAsHeader = false,
  zebraStriping = false,
}) => {
  return (
    <div className={styles.container}>
      <table
        className={cn(styles.table, {
          [styles.firstRowAsHeader]: firstRowAsHeader,
          [styles.primaryHeader]: primaryHeader,
          [styles.zebraStriping]: zebraStriping,
        })}
      >
        {firstRowAsHeader && table.content[0]?.content && (
          <thead>
            <tr>
              {table.content[0].content.map((cell, cellIndex) => {
                const content = cell.content as unknown[] as Document[]
                return (
                  <TableHeaderCell config={headerCellConfig} key={cellIndex}>
                    {content.map((content, index) => (
                      <span key={index}>{renderRichTextMultiLineContent(content)}</span>
                    ))}
                  </TableHeaderCell>
                )
              })}
            </tr>
          </thead>
        )}

        <tbody>
          {table.content.map((row, rowIndex) => {
            if (firstRowAsHeader && rowIndex === 0) {
              return null
            }
            return (
              <tr key={rowIndex}>
                {row.content.map((cell, cellIndex) => {
                  const content = cell.content as unknown[] as Document[]
                  const isHeader = firstColumnAsHeader && cellIndex === 0
                  if (isHeader) {
                    return (
                      <TableHeaderCell config={headerCellConfig} key={cellIndex}>
                        {content.map((content, index) => (
                          <span key={index}>{renderRichTextMultiLineContent(content)}</span>
                        ))}
                      </TableHeaderCell>
                    )
                  }

                  return (
                    <TableCell config={cellConfig} key={cellIndex}>
                      {content.map((content, index) => (
                        <span key={index}>{renderRichTextMultiLineContent(content)}</span>
                      ))}
                    </TableCell>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
